;(function() {
  'use strict'

  Controller.$inject = ["channelReportExporter", "glToast"];
  angular.module('app.core').component('channelReportExporter', {
    controller: Controller,
    templateUrl: 'channel-report-exporter.html',
    bindings: {
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(channelReportExporter, glToast) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onStartChange = onStartChange
    ctrl.onEndChange = onEndChange
    ctrl.export = doExport

    function onInit() {
      ctrl.today = moment().endOf('day')
      ctrl.startAt = moment().startOf('month')
      ctrl.endAt = ctrl.today
    }

    function onStartChange(date) {
      ctrl.startAt = date.startOf('day')
    }

    function onEndChange(date) {
      ctrl.endAt = date.endOf('day')
    }

    function doExport() {
      glToast.show('Starting download...', {
        target: '.main-content',
      })
      var url = channelReportExporter.getDownloadUrl(
        ctrl.startAt,
        ctrl.endAt
      )
      window.location.href = url
    }
  }
})()
